import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'
/**
 * Used for IDC rate calculations
 *
 * TODO: get better description
 */
export enum DaCategory {
  Student = 'STU',
  Faculty = 'FAC',
  GeneralSupport = 'GNS',
  BusinessOfficer = 'BUS',
}
// Needs to be before namespace is defined
const DA_CATEGORIES: ReadonlySet<DaCategory> = new Set(
  Object.values(DaCategory) as DaCategory[],
)
export namespace DaCategory {
  export const ALL: readonly DaCategory[] = Array.from(DA_CATEGORIES)
  export const isDaCategory =
    TypeChecker.Factory.oneOf(DA_CATEGORIES).usingAlias('DaCategory')
  export const assertIsDaCategory: TypeAsserter<DaCategory> =
    TypeAsserter.Factory.from(isDaCategory)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link DaCategory}
   */
  export function getEntry(
    daCategory: DaCategory,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[daCategory], id: daCategory }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    DaCategory,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [DaCategory.BusinessOfficer]: {
      name: 'Business Officer',
    },
    [DaCategory.Faculty]: {
      name: 'Faculty',
    },
    [DaCategory.GeneralSupport]: {
      name: 'General Support',
    },
    [DaCategory.Student]: {
      name: 'Student',
    },
  }

  /**
   * A {@link DaCategory} that is applicable for an employee. I.e. anything but
   * {@link DaCategory.Student}
   */
  export type ForEmployee = Exclude<DaCategory, DaCategory.Student>
  export namespace ForEmployee {
    export const isForEmployee = TypeChecker.Factory.exclude(
      isDaCategory,
      TypeChecker.Factory.exact(DaCategory.Student),
    ).usingAlias('DaCategory.ForEmployee')
    export const assertIsForEmployee: TypeAsserter<ForEmployee> =
      TypeAsserter.Factory.from(isForEmployee)

    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly ForEmployee[] =
      DaCategory.ALL.filter(isForEmployee)
  }
}
